import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { reportTemplate } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const reportTemplateSlice = createSlice({
    name: reportTemplate,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetailParams } = reportTemplateSlice.actions;
export default reportTemplateSlice.reducer;
